import { render, staticRenderFns } from "./r-item-boost-action.vue?vue&type=template&id=ffe0ec1c"
import script from "./r-item-boost-action.vue?vue&type=script&lang=js"
export * from "./r-item-boost-action.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ffe0ec1c')) {
      api.createRecord('ffe0ec1c', component.options)
    } else {
      api.reload('ffe0ec1c', component.options)
    }
    module.hot.accept("./r-item-boost-action.vue?vue&type=template&id=ffe0ec1c", function () {
      api.rerender('ffe0ec1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/item/boost/r-item-boost-action.vue"
export default component.exports